import qs from 'querystring'
import _ from 'lodash'
import createReducer from '../../../../../util/createReducer'
import * as http from '../../../../../util/http'

//constant
const API_PREFIX = '/photo-gallery'

const NAME_PREFIX = 'PHOTO_GALLERY';

const DEFAULT_SIZE = 12

const RECEIVE_LIST = `${NAME_PREFIX}_RECEIVE_LIST`

const RECEIVE_DETAIL = `${NAME_PREFIX}_RECEIVE_DETAIL`

export const CHANGE_PAGE = `${NAME_PREFIX}_CHANGE_PAGE`

export const CHANGE_QUERY = `${NAME_PREFIX}_CHANGE_QUERY`

export const SHOW_MODAL = `${NAME_PREFIX}_SHOW_MODAL`

export const HIDE_MODAL = `${NAME_PREFIX}_HIDE_MODAL`

export const CHANGE_FILTER_LIST = `${NAME_PREFIX}_CHANGE_FILTER_LIST`

function trimForm(formData) {
    const newFormData = {};
    Object.keys(formData).forEach(key=>{
        const value = formData[key];
        if (typeof(value) === 'string') {
            newFormData[key] = value.trim();
        } else {
            newFormData[key] = value;
        }
    })
    return newFormData;
}
//action
function getData(params, dispatch, form) {
    return http.post(`${API_PREFIX}/list?${qs.stringify(params)}`, form)
        .then(data => {
            dispatch({
                type: RECEIVE_LIST,
                data: data.data
            })
        })
}
export function getFormData(query, filterList) {
    const form = {
        "logic": "and",
        "filters": []
    }
    const keys = Object.keys(query);
    keys.forEach(key=>{
        if (query[key]) {
            form.filters.push({
                "field": key,
                "operator": filterList.find(item=>item.value === key).operator,
                "value": query[key]
            })
        }
    })
    return form;
}

export function getList() {
    return (dispatch,getState) => {
        const {photoGallery: {page, query, filterList}} = getState()
        const data = {
            page: page.index,
            size: page.size
        }
        const form = getFormData(query, filterList);
        getData(data, dispatch, form)
    };
}

export function add(formData) {
    return (dispatch, getState) => {
        let result = Promise.resolve();
        _.range(formData.count).forEach(() => {
            result = result.then(() => {
                return http.get(`http://yun-api.sungdell.com/random-img/${formData.width}x${formData.height}?${formData.keyword.trim()}`)
                    .then(data => {
                        formData.url = data.url;
                        return http.post(`${API_PREFIX}/add`, trimForm(formData))
                            .then(() => {
                                window.location.href = data.url.replace('x-oss-process=style/small', 'response-content-type=application%2Foctet-stream')
                            })
                    })
                    .then(() => {
                        return new Promise((resolve, reject) => {
                            setTimeout(() => {
                                resolve()
                            }, 3000)
                        })
                    })
            })
        });
        result = result.then(() => {
            dispatch({type: HIDE_MODAL})
            dispatch(getList())
        })
        return result;
    }
}

export function remove(id) {
    return (dispatch, getState) => {
        return http.get(`${API_PREFIX}/delete/${id}`)
            .then(() => {
                dispatch({type: HIDE_MODAL})
                dispatch(getList())
            })
    }
}
export function update(formData) {
    return (dispatch, getState) => {
        console.info(formData);
        return http.post(`${API_PREFIX}/update/${formData.id}`, trimForm(formData))
            .then(() => {
                dispatch({type: HIDE_MODAL})
                dispatch(getList())
            })
    }
}

export function showUpdateModal(id) {
    return (dispatch, getState) => {
        return http.get(`${API_PREFIX}/detail/${id}`)
            .then((data) => {
                dispatch({type: RECEIVE_DETAIL, detail: data.data})
                dispatch({type: SHOW_MODAL, key: 'update', id})
            })
    }
}

//reducers
const initialState = {
    list: [],
    page: {
        index: 0,
        size: DEFAULT_SIZE
    },
    total: 0,
    showModal: {
        add: false,
        delete: false,
        update: false,
        id: null
    },
    detail: {},
    filterList: [
        
            {"name": "链接", "componentType": "Text", "data": [], "isShow": false, "value": "url", "operator": "contains"},
            
            {"name": "关键词", "componentType": "Text", "data": [], "isShow": true, "value": "keyword", "operator": "contains"},

            {"name": "宽度", "componentType": "Number", "data": [], "isShow": true, "value": "width", "operator": "eq"},
        
            {"name": "高度", "componentType": "Number", "data": [], "isShow": true, "value": "height", "operator": "eq"},
        
            
        
            {"name": "标签", "componentType": "Text", "data": [], "isShow": false, "value": "labels", "operator": "contains"},
        
    ],
    query: {}
}

export default createReducer(initialState,{
    [RECEIVE_LIST]: (state,{data}) => {
        return {...state,...data}
    },
    [CHANGE_PAGE]: (state, {page}) => {
        return {...state, page}
    },
    [SHOW_MODAL]: (state,{key,id}) => {
        return {...state,showModal: {...state.showModal,[key]: true,id}}
    },
    [HIDE_MODAL]: (state) => {
        return {...state,showModal: initialState.showModal}
    },
    [CHANGE_FILTER_LIST]: (state,{value}) => {
        return {...state,filterList: value}
    },
    [CHANGE_QUERY]: (state,{key,value}) => {
        return {...state,query: {...state.query,[key]: value}, page: {index: 0, size: DEFAULT_SIZE}}
    },
    [RECEIVE_DETAIL]: (state, {detail}) => {
        return {...state, detail}
    }
})


// WEBPACK FOOTER //
// ./src/pages/home/routes/photo_gallery/reducers/list.js